export default "__VITE_ASSET__Bz2NBPek__"